import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router, RouterLink } from "@angular/router";
import { HasRoleDirective } from "@shared/directives/has-role/has-role.directive";
import { AuthService } from "../../../app/services/auth.service";
import { LocalStorageService } from "../../../app/services/local-storage.service";
import { NotificationStore } from "../../../app/services/notification.store";
import { SnackBarService } from "../../../app/services/snack-bar.service";
import { ModalSignupComponent } from "../modal-signup/modal-signup.component";

@Component({
  selector: "app-sidebar",
  imports: [CommonModule, HasRoleDirective, RouterLink],
  templateUrl: "./sidebar.component.html",
  styleUrl: "./sidebar.component.scss",
})
export class SidebarComponent {
  @Input() isProducerArea: boolean = false;
  @Input() navBarMode: boolean = false;
  isCollapsed: boolean = false;

  protected readonly notificationStore = inject(NotificationStore);

  constructor(
    private readonly dialog: MatDialog,
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly snackbarService: SnackBarService,
    private localStorageService: LocalStorageService,
  ) {}

  isActive(path: string, exact = false): boolean {
    const pathname = this.router.url.split(/[?#]/)[0];
    return exact ? pathname === path : pathname.startsWith(path);
  }

  openModalSignUp() {
    this.dialog.open(ModalSignupComponent, {
      width: "800px",
      maxWidth: "95vw",
    });
  }

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
  }

  logout() {
    this.authService.logout().subscribe({
      next: (response) => {
        if (response.status === 200) {
          this.snackbarService.openSnackBar(
            "Logout Efetuado com sucesso!",
            "Fechar",
            "success",
          );
          this.router.navigate(["/"]);
        }
      },
      error: (error) => {
        console.error("Erro durante o logout", error);
      },
    });
    this.localStorageService.clear();
    setTimeout(() => window.location.reload(), 1000);
  }
}
